import { createBrowserRouter, Navigate } from "react-router-dom";
import { hasTokens } from "@crm/utils";

// Layouts
import { AppLayout } from "./components/layout/AppLayout";
import { AuthLayout } from "./components/layout/AuthLayout";

// Pages
import { LoginPage } from "./features/auth/pages/LoginPage";
import { DashboardPage } from "./features/dashboard/pages/DashboardPage";
import { IncidentsListPage } from "./features/incidents/pages/IncidentsListPage";
import { IncidentDetailPage } from "./features/incidents/pages/IncidentDetailPage";
import { CreateIncidentPage } from "./features/incidents/pages/CreateIncidentPage";
import { WorkersListPage } from "./features/workers/pages/WorkersListPage";
import { ClientsListPage } from "./features/clients/pages/ClientsListPage";

/** Protected route wrapper */
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  if (!hasTokens()) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}

/** Public route wrapper (redirect if authenticated) */
function PublicRoute({ children }: { children: React.ReactNode }) {
  if (hasTokens()) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}

export const router = createBrowserRouter([
  // Auth routes
  {
    element: <AuthLayout />,
    children: [
      {
        path: "/login",
        element: (
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        ),
      },
    ],
  },
  // App routes (protected)
  {
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "/",
        element: <DashboardPage />,
      },
      {
        path: "/incidents",
        element: <IncidentsListPage />,
      },
      {
        path: "/incidents/new",
        element: <CreateIncidentPage />,
      },
      {
        path: "/incidents/:id",
        element: <IncidentDetailPage />,
      },
      {
        path: "/workers",
        element: <WorkersListPage />,
      },
      {
        path: "/clients",
        element: <ClientsListPage />,
      },
    ],
  },
  // Fallback
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
]);
